var React = require('react');

function IconMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M3 3v10.667h10.667V3zm8 8H5.667V5.667H11zm-8 5.333V27h10.667V16.333zm8 8H5.667V19H11zM16.333 3v10.667H27V3zm8 8H19V5.667h5.333zm-8 5.333V27H27V16.333zm8 8H19V19h5.333z","transform":"translate(-3 -3)"}));
}

IconMenu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconMenu;

IconMenu.default = IconMenu;
